﻿import { AppServices } from "./AppServices";

export class ShippingPageController {
   private appServices_ = new AppServices();
   constructor(appServices: AppServices) {
      this.appServices_ = appServices;
   }

   public validate(): boolean {
      const selectedRadio = document.querySelector('input[name="SelectedShippingMethodID"]:checked');

      if (selectedRadio !== null) {
         const isPickup = selectedRadio.hasAttribute('data-bu-ispickup');
         if (isPickup) {
            const isValid = selectedRadio.getAttribute('data-bu-pickup-valid') === 'true';
            if (!isValid) {
               const message = 'Wybierz punkt odbioru aby kontynuować.';
               this.appServices_.modalService.showMessageModal(message);
               return false;
            }
         }
      }
      return true;
   }

   public onSelectedCarrierPickup(resultElId: string, shippingMethodId: number, json: string): void {
      const resultEl = document.getElementById(resultElId) as HTMLInputElement;
      if (resultEl) {
         resultEl.value = json;

         const inpEl = document.querySelector(`[data-bu-shid="${shippingMethodId}"]`);
         inpEl?.setAttribute('data-bu-pickup-valid', 'true');
         document.getElementById('shippingSubmit')?.click();
      }         
   }
}